import { Injectable } from '@angular/core';
import { StarbaseDataServiceWithRequisites } from 'starbase-launcher';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';
import { Battle } from '../models/battle';

@Injectable({
  providedIn: 'root'
})
export class BattleDataService extends StarbaseDataServiceWithRequisites<Battle> {
  protected _staleDataTimeout = 2000;
  protected _getOneUri = '/api/Battle/';
  protected _getAllUri = '/api/Battle';
  protected _postUri = '/api/Battle';
  protected _putUri = '/api/Battle/';
  protected _deleteUri = '/api/Battle/';
  protected _broadSearchUri = '/api/Battle/GetBattlesBroadSearch';

  constructor(private _http: HttpClient, private _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }

}
